import React, { useState, useEffect } from 'react';
import ReactDOM from "react-dom";
import UseContext from "hooks/useContext";
import SlideOverStructure from "../component/structure";
import DataSlideOver from "../dataSlideOver";
import { INVOICE_DETAIL_SLIDE_OVER } from "components/invoiceDetail/useOpenInvoiceDetail";

// Panels wider than the default 800 px: the invoice detail shows its PDF
// beside its information (JBWEB-1274).
const PANEL_WIDTHS = {
    [INVOICE_DETAIL_SLIDE_OVER]: 'lg:w-[1200px]',
};

const Index = () => {
    const {slideOverShow, slideOverType} = UseContext()
    const [showCV, setShowCV] = useState(false);

    // Réinitialiser showCV quand le slideOver se ferme ou change de type
    useEffect(() => {
        if (!slideOverShow || slideOverType !== 'get_temp_worker') {
            setShowCV(false);
        }
    }, [slideOverShow, slideOverType]);

    if(!slideOverShow) return null

    return ReactDOM.createPortal(
        <SlideOverStructure isShowing={slideOverShow} showCV={showCV && slideOverType === 'get_temp_worker'} width={PANEL_WIDTHS[slideOverType]}>
            <DataSlideOver setShowCV={setShowCV} />
        </SlideOverStructure>
        , document.getElementById('root-portal'));
};

export default Index;